import { render, staticRenderFns } from "./projectDrawing.vue?vue&type=template&id=bfbb8f42&scoped=true"
import script from "./projectDrawing.vue?vue&type=script&lang=js"
export * from "./projectDrawing.vue?vue&type=script&lang=js"
import style0 from "./projectDrawing.vue?vue&type=style&index=0&id=bfbb8f42&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbb8f42",
  null
  
)

export default component.exports